import { useEffect } from 'react'
import { useCreateVideoInstructionMutation } from 'services/video-instructions'
import { VideoFieldValues, VideoForm } from './video-form'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

type Props = {
  id: string
  defaultValues: VideoFieldValues
  onClose: () => void
}

export const DialogEditVideo = ({ id, defaultValues, onClose }: Props) => {
  const { t } = useTranslation()
  const [createVideoInstruction, { isSuccess, isError }] =
    useCreateVideoInstructionMutation()

  useEffect(() => {
    if (isSuccess) {
      onClose()
      toast.success(t('operation-success'))
    }
    if (isError) {
      toast.error(t('failedToCreate'))
    }
  }, [isSuccess, isError, t, onClose])

  return (
    <VideoForm
      onClose={onClose}
      defaultValues={defaultValues}
      isEditing
      onSubmit={({
        title,
        description,
        videoUrl,
        ordinal,
        audienceOrganizationType,
        instructionFileId,
      }: VideoFieldValues) => {
        createVideoInstruction({
          id,
          title,
          description,
          videoUrl,
          ordinal,
          audienceOrganizationType,
          instructionFileId,
        })
      }}
    />
  )
}
